import React from 'react';
import { CHECKOUT_URL } from '../data/hvac';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  sub?: string;
  /** Use 'light' when the button sits on a dark background. */
  subTone?: 'dark' | 'light';
}
export function CTAButton({
  children,
  className = '',
  sub,
  subTone = 'dark'
}: CTAButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-29" data-mp="2fya7vibp9b8e">
      <a href={CHECKOUT_URL} className="block w-full rounded-lg bg-cta px-4 py-3 text-center font-display text-base uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#0F7A38] transition-transform duration-150 ease-soft hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cta sm:text-lg" data-id="element-30" data-mp="2tyums3ehumwm">
        {children}
      </a>
      {sub && <p className={`mt-1 text-center text-[11px] font-semibold sm:text-xs ${subTone === 'light' ? 'text-white/80' : 'text-charcoal/70'}`} data-id="element-31" data-mp="3cq3zeljk9rsf">
          {sub}
        </p>}
    </div>;
}